import React, { useContext, useEffect, useState } from 'react';
import * as S from './styleBenefits';
import * as SB from './styles';

import {
  KenloSignatureTextIcon,
  KenloSignatureTextIconLarge,
} from 'components/Icons';
import { Close } from 'styled-icons/ionicons-outline';
import frame1 from 'assets/image/Frame1.png';
import frame2 from 'assets/image/Frame2.png';
import frame3 from 'assets/image/Frame3.png';
import frame4 from 'assets/image/Frame4.png';
import frame5 from 'assets/image/Frame5.png';
import { FeatureContext } from 'contexts/FeaturesContext';
interface IBenefitsSignature {
  closeDrawer: () => void;
  setDrawerOption: () => void;
}

const infos = [
  {
    text: (
      <SB.TextInfos lineWeight="500">
        Assine sem sair do sistema e mantenha{' '}
        <SB.TextInfos color="#298EE6" >tudo integrado à kenlo</SB.TextInfos>
      </SB.TextInfos>
    ),
    image: frame1,
    alt: '',
  },
  {
    text: (
      <SB.TextInfos lineWeight="500">
        Documentos e signatários{' '}
        <SB.TextInfos color="#298EE6">ilimitados por envelope</SB.TextInfos>
      </SB.TextInfos>
    ),
    image: frame2,
    alt: '',
  },
  {
    text: (
      <SB.TextInfos lineWeight="500">
        Assinaturas com{' '}
        <SB.TextInfos color="#298EE6">
          prova de vida e verificação facial
        </SB.TextInfos>
      </SB.TextInfos>
    ),
    image: frame3,
    alt: '',
  },
  {
    text: (
      <SB.TextInfos lineWeight="500">
        Defina a{' '}
        <SB.TextInfos color="#298EE6"> ordem dos participantes </SB.TextInfos>e
        adicione mais até o último minuto
      </SB.TextInfos>
    ),
    image: frame4,
    alt: '',
  },
  {
    text: (
      <SB.TextInfos lineWeight="500">
        Acompanhe{' '}
        <SB.TextInfos color="#298EE6">
          tudo o que acontece na assinatura{' '}
        </SB.TextInfos>
        em detalhes
      </SB.TextInfos>
    ),
    image: frame5,
    alt: '',
  },
];
const BenefitsSignature = ({
  closeDrawer,
}: IBenefitsSignature) => {
  const [isMobile, setIsMobile] = useState(false);
    const { dataAgency } = useContext(FeatureContext);
   const nameUser = localStorage.getItem('name')
    ? localStorage.getItem('name')
    : 'User not found';
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 600);
    };

    // Verificar no carregamento
    checkMobile();

    // Adicionar event listener para mudanças de largura
    window.addEventListener('resize', checkMobile);

    // Limpar event listener
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  const openWhatsapp = async () => {
    const message = `Olá, aqui é ${nameUser} da ${dataAgency?.name}. Quero seguir com a contratação do Kenlo Assinaturas. Fico no aguardo do retorno para a ativação!`
    window.open(
      `https://wa.me/5511992359399?text=${message}`,'_blank'
    )
  }
  return (
    <>
      <S.ScreenContainer>
        <S.ScrollableArea>
          <S.HeaderBenefits>
            <S.CloseBenefits>
              {isMobile ? (
                <KenloSignatureTextIcon />
              ) : (
                <KenloSignatureTextIconLarge />
              )}
              <Close size={24} onClick={closeDrawer} />
            </S.CloseBenefits>
            <S.Subtitle>
              <SB.TextInfos size="24">
                Feche contratos digitais com segurança jurídica e mais
                agilidade.
              </SB.TextInfos>{' '}
            </S.Subtitle>
          </S.HeaderBenefits>

          <S.VideoContainer>
            <iframe
              src="https://www.youtube.com/embed/AdZ4N4EZ8Rs"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </S.VideoContainer>

          <S.Main>
            {infos.map((info, index) => (
              <SB.ContentContainer key={index}>
                <SB.TextContent>{info.text}</SB.TextContent>
                <SB.ImageContent>
                  <img src={info.image} alt={info.alt} />
                </SB.ImageContent>
              </SB.ContentContainer>
            ))}
          </S.Main>
        </S.ScrollableArea>

        <S.Footer>
          <SB.CustomButton variant="secondary"> Saiba mais</SB.CustomButton>
          <SB.CustomButton variant="primary" onClick={openWhatsapp}>
            Contratar
          </SB.CustomButton>
        </S.Footer>
      </S.ScreenContainer>
    </>
  );
};
export default BenefitsSignature;
